import { type ReactNode } from 'react';
import { COLORS } from '../../constants/style/color';
import { type ModalStatusType } from '../../types/common';
import CheckPermissions from '../../utils/permission/checkPermission';
import Spinners from '../spinner';
import { Btn } from './button.styled';

interface ButtonType {
  variant:
  | 'primary'
  | 'primary-outline'
  | 'primary-dark'
  | 'primary-danger'
  | 'primary-import'
  | 'approve'
  | 'secondary'
  | 'secondary-dark'
  | 'secondary-gray-dark'
  | 'secondary-outline'
  | 'links'
  | 'rounded'
  | 'rounded-icon-only'
  | 'secondary-gray'
  | 'secondary-red'
  | 'secondary-red-outline'
  | 'small-icon-dark'
  | string;
  icon?: string | ReactNode;
  trailingIcon?: string | ReactNode;
  title: string | ReactNode;
  onClick?: any;
  btnClassName?: string;
  loading?: boolean;
  disabled?: boolean;
  as?: ModalStatusType;
  hasId?: string;
  id?: string;
  type?: 'button' | 'submit' | 'reset';
  fontColor?: string;
  borderColor?: string;
  selected?: boolean;
}

const Button = ({
  variant,
  icon,
  trailingIcon,
  title,
  onClick,
  btnClassName,
  loading,
  type,
  disabled,
  hasId,
  id,
  as,
  fontColor,
  borderColor,
  selected,
  ...rest
}: ButtonType): JSX.Element => {
  return (
    <CheckPermissions type={as} urlName={hasId}>
      <Btn
        className={btnClassName}
        id={id}
        type={type}
        variant={variant}
        onClick={onClick}
        fontColor={fontColor}
        borderColor={borderColor}
        as='button'
        disabled={(disabled ?? false) || loading}
        selected={selected}
        {...rest}>
        {icon != null && (
          <span className={`material-symbols-outlined ${title != null ? 'pr-0' : ''}`}>{icon}</span>
        )}
        {loading ?? false ? <Spinners borderColor={COLORS.White} size='sm' /> : title}
        {trailingIcon != null && (
          <span className='material-symbols-outlined pl-1'>{trailingIcon}</span>
        )}
      </Btn>
    </CheckPermissions>
  );
};

export default Button;
